import React from 'react';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../redux/snackbarSlice';

/**
 * DeleteReplaceConfirmModal Component
 * Modal popup for confirming delete operation
 */
const DeleteReplaceConfirmModal = ({
  deleteDocument,
  deleteNode,
  comment,
  onCommentChange,
  onClose,
  onSave,
  isLoading,
  procedureType
}) => {
  const dispatch = useDispatch();

  const handleSave = () => {
    if (!comment || !comment.trim()) {
      dispatch(showSnackbar({ message: 'Comment is mandatory.', type: 'error' }));
      return;
    }
    onSave();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content_addsection">
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <h4
            style={{
              marginLeft: "23px",
              fontSize: "18px",
              color: "#333333",
            }}
          >
            {deleteNode 
              ? `Confirm Delete ${deleteNode.nodeTitle} of ${deleteDocument.partNumber}`
              : `Confirm Delete`
            }
          </h4>
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              right: "10px",
              top: "10px",
              background: "none",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              color: "#666",
            }}
            disabled={isLoading}
          >
            ✕
          </button>
        </div>

        {/* Modal Body */}
        <div
          style={{ padding: "24px", marginTop: "-28px", color: "#333333" }}
        >
          <h4 style={{ fontSize: "14px" }}>
            For {procedureType || deleteDocument.type} {deleteDocument.partNumber} - Rev {deleteDocument.revision}
          </h4>

          <p style={{ fontSize: "14px", color: "#333333" }}>
            <strong>Editor:</strong>{" "}
            <span style={{ marginLeft: "10px" }}>
              {localStorage.getItem("user_name")}
            </span>
          </p>

          <label
            className="modal-label"
            style={{ fontSize: "14px", color: "#333333" }}
          >
            Comment
            <span className="required" style={{ marginLeft: "-1px" }}>
              *
            </span>
          </label>
          <textarea
            className="modal-textarea"
            placeholder="Enter your comments here..."
            value={comment || ''}
            onChange={(e) => onCommentChange(e.target.value)}
            style={{
              width: "100%",
              minHeight: "100px",
              padding: "8px",
              border: "1px solid #ddd",
              borderRadius: "4px",
            }}
            disabled={isLoading}
          ></textarea>
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "16px 24px",
            borderTop: "1px solid #e0e0e0",
            marginTop: "-10px",
            position: "relative",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              background: "#6c757d",
              color: "#e9ecef",
              cursor: isLoading ? "not-allowed" : "pointer",
            }}
            disabled={isLoading}
          >
            Close
          </button>
          <button
            onClick={handleSave}
            style={{
              padding: "8px 16px",
              border: "1px solid rgb(0, 123, 255)",
              borderRadius: "4px",
              background: "rgb(0, 123, 255)",
              color: "white",
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? 0.7 : 1,
            }}
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteReplaceConfirmModal;

